import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from 'app/shared/services/settings.service';
import { ToastrService } from 'ngx-toastr';
import { SettingsBaseComponent } from '../settings-base/settings-base.component';

@Component({
  selector: 'app-ibanxs-settings',
  templateUrl: './ibanxs-settings.component.html',
  styleUrls: ['./ibanxs-settings.component.scss']
})

export class IbanXSSettingsComponent extends SettingsBaseComponent implements OnInit {

  constructor(protected formBuilder: FormBuilder, protected settingsService: SettingsService, protected toastrService: ToastrService, translateService: TranslateService) {
    super(formBuilder, settingsService, toastrService, translateService);
  }

  ngOnInit() {
  }
}
